import { render, staticRenderFns } from "./EmergencyHandling.vue?vue&type=template&id=2a9ac9c0&scoped=true&"
import script from "./EmergencyHandling.vue?vue&type=script&lang=js&"
export * from "./EmergencyHandling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9ac9c0",
  null
  
)

export default component.exports